/* This is generated code, don't alter */
var IfcPipeFittingTypeEnum;
(function (IfcPipeFittingTypeEnum) {
    IfcPipeFittingTypeEnum[IfcPipeFittingTypeEnum["BEND"] = 0] = "BEND";
    IfcPipeFittingTypeEnum[IfcPipeFittingTypeEnum["CONNECTOR"] = 1] = "CONNECTOR";
    IfcPipeFittingTypeEnum[IfcPipeFittingTypeEnum["ENTRY"] = 2] = "ENTRY";
    IfcPipeFittingTypeEnum[IfcPipeFittingTypeEnum["EXIT"] = 3] = "EXIT";
    IfcPipeFittingTypeEnum[IfcPipeFittingTypeEnum["JUNCTION"] = 4] = "JUNCTION";
    IfcPipeFittingTypeEnum[IfcPipeFittingTypeEnum["OBSTRUCTION"] = 5] = "OBSTRUCTION";
    IfcPipeFittingTypeEnum[IfcPipeFittingTypeEnum["TRANSITION"] = 6] = "TRANSITION";
    IfcPipeFittingTypeEnum[IfcPipeFittingTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcPipeFittingTypeEnum[IfcPipeFittingTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcPipeFittingTypeEnum || (IfcPipeFittingTypeEnum = {}));
const IfcPipeFittingTypeEnumCount = 9;
export { IfcPipeFittingTypeEnum, IfcPipeFittingTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcPipeFittingTypeEnum = new Int32Array([1, 15, -1]);
let prefixSumAddressIfcPipeFittingTypeEnum = new Uint32Array([0, 11, 23, 36, 48, 54, 64, 77, 83, 90]);
let slotMapIfcPipeFittingTypeEnum = new Int32Array([1, 8, 5, 6, 0, 4, 7, 3, 2]);
let encodedDataIfcPipeFittingTypeEnum = (new TextEncoder()).encode(".CONNECTOR..NOTDEFINED..OBSTRUCTION..TRANSITION..BEND..JUNCTION..USERDEFINED..EXIT..ENTRY.");
let IfcPipeFittingTypeEnumSearch = new MinimalPerfectHash(gMapIfcPipeFittingTypeEnum, prefixSumAddressIfcPipeFittingTypeEnum, slotMapIfcPipeFittingTypeEnum, encodedDataIfcPipeFittingTypeEnum);
export { IfcPipeFittingTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcPipeFittingTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcPipeFittingTypeEnumSearch, input, cursor, endCursor);
}
